import { useMutation } from "@tanstack/react-query";
import { createGeneralAssistant } from "../api/createGeneralAssistant";

export const useCreateGeneralAssistantMutation = () => {
  return useMutation({
    mutationFn: createGeneralAssistant,
  });
};
